import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map'

@Injectable()
export class ForgetService {
    private apiURL: string = 'https://reqres.in/api/';
    constructor(private http: Http) { }

    forget(email: string): Observable<boolean> {
        const headers = new Headers({ 'Content-Type': 'application/json' });
        const options = new RequestOptions({ headers });
        return this.http.post(`${this.apiURL}/account/reset/${email}`, options)
            .map((response: Response) => {
                if (response) {
                } else {
                    return false;
                }
            }).catch(error => {
                return Observable.of(false);
            });
    }


}


// WEBPACK FOOTER //
// ./src/app/login/AuthService/forget.service.ts